import {
  PitchTypeRangesChartConfigDto,
  PracticePitcherSingleSessionReportChartConfigDto,
  PitchTypeRangesMeasurementOptions,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';

const options: PitchTypeRangesMeasurementOptions[] = ['Velocity', 'SpinRate', 'InducedVerticalBreak', 'HorizontalBreak'];

const PracticePitcherSingleSessionPitchTypeRangesChartSidebar = ({
  chartConfig,
  setTempLayout,
  tempLayout,
}: ChartConfigProps<PitchTypeRangesChartConfigDto, PracticePitcherSingleSessionReportChartConfigDto>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle('PitcherSingleSessionPitchTypeRangesChart', chartConfig)}
      </Typography>

      <GenericRadioConfig
        label={t('X-Axis')}
        options={options}
        selected={chartConfig.selectedMeasurementOption}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            practicePitcherSingleSessionPitchTypeRangesChartConfig: {
              ...tempLayout.practicePitcherSingleSessionPitchTypeRangesChartConfig,
              selectedMeasurementOption: selected,
            },
          })
        }
        disabled={false}
      />
    </div>
  );
};

export default PracticePitcherSingleSessionPitchTypeRangesChartSidebar;
